import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import Button from "../../../components/shared/buttons/button";
import toast from "react-hot-toast";
import useTranslator from "../../../hooks/useTranslator";

const TreysCompletedModal = ({ show, setShow, record, mode, onSave, date, lotNumber }) => {
  const { _t } = useTranslator();

  const initialFormData = {
    lot_number: lotNumber || "",
    total_cart: "",
    total_cheeks_tray: "",
    total_strips_tray: "",
    total_tapita_tray: "",
    cart_not_completed: "",
    date: date || "",
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (show) {
      if (record && mode === "edit") {
        setFormData({
          lot_number: record.lot_number || lotNumber || "",
          total_cart: record.total_cart || "",
          total_cheeks_tray: record.total_cheeks_tray || "",
          total_strips_tray: record.total_strips_tray || "",
          total_tapita_tray: record.total_tapita_tray || "",
          cart_not_completed: record.cart_not_completed || "",
          date: date || "",
        });
      } else {
        setFormData({
          ...initialFormData,
          lot_number: lotNumber || "",
          date: date || "",
        });
      }
    }
  }, [show, record, mode, date, lotNumber]);

  const handleClose = () => {
    setShow(false);
    setFormData(initialFormData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const requiredFields = [
      {
        key: "total_cart",
        label: _t("total_cart_completed", "Total Cart Completed"),
      },
      {
        key: "cart_not_completed",
        label: _t("cart_not_completed", "Cart Not Completed"),
      },
      {
        key: "total_cheeks_tray",
        label: _t("cheeks_tray_completed", "Cheeks Tray Completed"),
      },
      {
        key: "total_strips_tray",
        label: _t("strips_tray_completed", "Strips Tray Completed"),
      },
      {
        key: "total_tapita_tray",
        label: _t("tapita_tray_completed", "Tarpita Trey Completed"),
      },
    ];

    const emptyField = requiredFields.find(({ key }) => {
      const value = formData[key];
      return value === "" || value === null || value === undefined;
    });

    if (emptyField) {
      return toast.error(
        _t(
          "all_trays_completed_values_required",
          `Please enter :field before submitting.`,
          {field : emptyField.label}
        )
      );
    }

    // Call the onSave callback with form data
    if (onSave) {
      onSave(formData);
    }
    handleClose();
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "edit"
          ? _t("edit_treys_completed", "Edit Trays Completed")
          : _t("add_treys_completed", "Add Trays Completed")
      }
      children={formData}
    >
      <Row className="mb-3">
        <Col lg={12}>
          <InputWithLabel
            label={_t("lot_number", "Lot Number")}
            type="text"
            name="lot_number"
            value={formData.lot_number}
            onChange={handleChange}
            disabled={true}
            placeholder="Lot Number"
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col lg={6}>
          <InputWithLabel
            label={_t("total_cart_completed", "Total Cart Completed")}
            type="number"
            name="total_cart"
            value={formData.total_cart}
            onChange={handleChange}
            placeholder={"0"}
            required={true}
          />
        </Col>
      
        <Col lg={6}>
          <InputWithLabel
            label={_t("cart_not_completed", "Cart Not Completed")}
            type="number"
            name="cart_not_completed"
            value={formData.cart_not_completed}
            onChange={handleChange}
            placeholder={"0"}
            required={true}
          />
        </Col>
      </Row>
      <Row className="mb-3">
          <Col lg={4}>
            <InputWithLabel
              label={_t("cheeks_tray_completed", "Cheeks Tray Completed")}
              type="number"
              name="total_cheeks_tray"
              value={formData.total_cheeks_tray}
              onChange={handleChange}
              placeholder={"0"}
              required={true}
            />
          </Col>
          <Col lg={4}>
            <InputWithLabel
              label={_t("strips_tray_completed", "Strips Tray Completed")}
              type="number"
              name="total_strips_tray"
              value={formData.total_strips_tray}
              onChange={handleChange}
              placeholder={"0"}
              required={true}
            />
          </Col>
          <Col lg={4}>
            <InputWithLabel
              label={_t("tapita_tray_completed", "Tarpita Trey Completed")}
              type="number"
              name="total_tapita_tray"
              value={formData.total_tapita_tray}
              onChange={handleChange}
              placeholder={"0"}
              required={true}
            />
          </Col>
      </Row>

      <Row className="mt-3">
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default TreysCompletedModal;
